/* eslint-disable no-control-regex, no-return-assign, no-param-reassign */

import React, { useState, useRef } from 'react';
import loadPianoData from '../piano_pages_state_manager';
import clsx from 'clsx';
import { Redirect } from 'react-router';

const GroupSubscriptions = () => {
  const [message, setMessage] = useState(null);
  const [subsGreaterThanTen, setSubsGreaterThanTen] = useState(undefined);
  const [submitted, setSubmitted] = useState(false);
  const numberOfSubsRef = useRef();
  const showSubscriptionCountError =
    !subsGreaterThanTen && typeof subsGreaterThanTen !== 'undefined';

  const submitForm = () => {
    if (!submitted) {
      let error = false;

      const formData = new FormData();
      const formFields = document
        .querySelectorAll('main.group-subscriptions')[0]
        .querySelectorAll('.form input, .form > select');

      formFields.forEach(field => {
        const { name, type, value } = field;

        switch (type) {
          case 'select-one':
          case 'number':
          case 'text':
            if (!value) {
              field.classList.add(clsx('group-subscriptions__form--error'));
              error = true;
            } else {
              field.classList.remove(clsx('group-subscriptions__form--error'));
              formData.append(name, value);
            }

            break;

          case 'email':
            if (value.match(/^[^@]+@\w+(?:\.\w+)?\.\w{2,}$/gi)) {
              field.classList.remove(clsx('group-subscriptions__form--error'));
              formData.append(name, value);
            } else {
              field.classList.add(clsx('group-subscriptions__form--error'));
              error = true;
            }

            break;

          default:
            formData.append(name, value);
            break;
        }
      });

      if (showSubscriptionCountError) {
        numberOfSubsRef.current.classList.add(
          clsx('group-subscriptions__form--error')
        );
        error = true;
      } else {
        numberOfSubsRef.current.classList.remove(
          clsx('group-subscriptions__form--error')
        );
      }

      if (error) {
        setMessage('Missing or invalid information entered.');
        return false;
      }

      setMessage('Sending...');

      const request = new XMLHttpRequest();

      request.open('POST', 'https://www.inc.com/rest/group-subscriptions.php');
      request.send(formData);

      request.addEventListener('load', () => {
        setMessage('Success! We will be in touch soon!');
        formFields.forEach(field => (field.disabled = true));
        document.querySelector(
          '.group-subscriptions__form--button'
        ).style.cursor =
          'not-allowed';
        setSubmitted(true);
      });

      request.addEventListener('error', () =>
        setMessage('Something went wrong... Please try again.')
      );
    }

    return true;
  };

  const validateNumOfSubs = () => {
    const numberOfSubs = parseInt(numberOfSubsRef.current.value, 10);

    if (!numberOfSubs) {
      setSubsGreaterThanTen(undefined);
    } else if (numberOfSubs >= 10) {
      setSubsGreaterThanTen(true);
    } else {
      setSubsGreaterThanTen(false);
    }
  };

  const boxes = [
    {
      icon:
        'https://assets.fastcompany.com/image/upload/v1673982012/piano/group-sub-pricing_icon.svg',
      label: 'Pricing',
      copy: 'Enjoy discounted subscription pricing that fits your needs.'
    },
    {
      icon:
        'https://assets.fastcompany.com/image/upload/v1673982008/piano/group-sub-benefits_icon.svg',
      label: 'Benefits',
      copy:
        'Customize your subscription plan with unlimited access to our invaluable coverage.'
    },
    {
      icon:
        'https://assets.fastcompany.com/image/upload/v1673982002/piano/group-sub-support_icon.svg',
      label: 'Support',
      copy: 'Receive complete support from our Subscriber Care Team.'
    }
  ];

  if (submitted) return <Redirect to="/groupsubscriptions/success" />;

  return (
    <main className={clsx('group-subscriptions')}>
      <div className={clsx('group-subscriptions__wrapper')}>
        <div className={clsx('group-subscriptions__container')}>
          <section className={clsx('group-subscriptions__content')}>
            <h1 className={clsx('group-subscriptions__content--hed')}>
              Fast Company Premium{' '}
              <span className={clsx('primary')}>Group Subscriptions</span>
            </h1>

            <div className={clsx('group-subscriptions__content--dek')}>
              Keep your team on the forefront of design, technology,
              world-changing ideas, and more with our award-winning reporting.
            </div>
          </section>

          <div className={clsx('group-subscriptions__stripe')}>
            <div className={clsx('group-subscriptions__boxes')}>
              {boxes.map(box => (
                <div
                  className={clsx('group-subscriptions__boxes--box', box.label)}
                  key={`box-${box.label}`}
                >
                  <div
                    className={clsx(
                      'group-subscriptions__boxes--box__icon',
                      box.label
                    )}
                  >
                    <img src={box.icon} alt="icon" />
                  </div>
                  <div
                    className={clsx('group-subscriptions__boxes--box__label')}
                  >
                    {box.label}
                  </div>
                  <div
                    className={clsx(
                      'group-subscriptions__boxes--box__copy',
                      box.label
                    )}
                  >
                    {box.copy}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className={clsx('group-subscriptions__subhed')}>
            Send an Inquiry
          </div>
          <div className={clsx('group-subscriptions__subdek')}>
            More information is available for{' '}
            <a
              href="https://assets.fastcompany.com/image/upload/v1668195788/magazine/FC-GroupSubscriptions.pdf"
              className="grey link_underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              download here
            </a>.
          </div>

          <div className={clsx('group-subscriptions__form--wrapper')}>
            <div className={clsx('form', 'group-subscriptions__form')}>
              <input
                className={clsx('group-subscriptions__form--input')}
                type="text"
                name="organization"
                placeholder="Organization"
                required
              />
              <input
                className={clsx('group-subscriptions__form--input')}
                type="email"
                name="email"
                placeholder="Email"
                required
              />
              <input
                className={clsx('group-subscriptions__form--input')}
                type="text"
                name="first_name"
                placeholder="First Name"
                required
              />
              <input
                className={clsx('group-subscriptions__form--input')}
                type="text"
                name="last_name"
                placeholder="Last Name"
                required
              />
              <div>
                <input
                  className={clsx('group-subscriptions__form--input')}
                  type="number"
                  name="number_of_subscriptions"
                  placeholder="# of Subscriptions"
                  min={1}
                  required
                  onBlur={validateNumOfSubs}
                  ref={numberOfSubsRef}
                />
                <p
                  className={clsx(
                    'group-subscriptions__form--min-sub-err',
                    showSubscriptionCountError && 'show'
                  )}
                >
                  If you are interested in a group subscription for fewer than
                  10, please contact{' '}
                  <a
                    href="mailto:subscriptions@fastcompany.com"
                    className="link_underline"
                  >
                    subscriptions@fastcompany.com
                  </a>{' '}
                  to make the request.
                </p>
              </div>

              <select
                className={clsx(
                  'group-subscriptions__form--input',
                  'group-subscriptions__form--select'
                )}
                name="subscription_type"
                required
              >
                <option value="">Subscription Type</option>
                <option value="Print and Digital">Print and Digital</option>
                <option value="Digital Only">Digital Only</option>
                <option value="Unsure">I{`'`}m Not Sure</option>
              </select>

              <input type="hidden" name="site" defaultValue="fastcompany" />
            </div>
            <button
              className={clsx('group-subscriptions__form--button')}
              onClick={() => submitForm()}
            >
              SUBMIT
            </button>

            <div className={clsx('group-subscriptions__form--message')}>
              {message}
            </div>
          </div>
        </div>
      </div>
      <button className="contact-us">
        Contact Us
        <a href="mailto:subscriptions@fastcompany.com" />
      </button>
    </main>
  );
};

GroupSubscriptions.loadData = store => loadPianoData(store);

export default GroupSubscriptions;
